import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {VendedoresList} from 'components/vendedores/list/vendedores.list';
import {VendedoresEdit} from 'components/vendedores/edit/vendedores.edit';
import {MainContext} from "contexts/main.context";

const basePath = '/vendedores';

// Solo administradores y operadores administran vendedores.
const AUTHORIZED_ROLES = ["A", "O"];

export class Vendedores extends Component {
    componentDidMount() {
        this.context.setHeaderTitle('Vendedores');
    }

    render() {
        if (!AUTHORIZED_ROLES.includes(this.context.loggedUser.role))
            return <Redirect to='/home'/>;

        return (
            <div className='niquel-vendedores'>
                <Switch>
                    <Route path={`${basePath}/edit/:vendedor`} component={VendedoresEdit}/>
                    <Route path={`${basePath}`} component={VendedoresList}/>
                </Switch>
            </div>
        )
    }
}

Vendedores.contextType = MainContext;
